import React from 'react';
import { motion } from 'framer-motion';
export function ProcessSection() {
  const phases = [{
    number: '1',
    title: 'Fase de Vacío',
    duration: '72hs',
    desc: 'Eliminamos los disparadores y deshinchamos el cuerpo.'
  }, {
    number: '2',
    title: 'Fase de Reprogramación',
    duration: 'Días 4-21',
    desc: 'Introducimos alimentos que sanan tu microbiota.'
  }, {
    number: '3',
    title: 'Fase de Estabilización',
    duration: 'Días 22-30',
    desc: 'Sellamos el hábito para que la inflamación no regrese.'
  }];
  return <section className="py-20 bg-white" data-id="element-88">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-91">
            Cómo Funciona
          </h2>
          <p className="text-lg text-stone-600" data-id="element-92">
            Un proceso de 3 fases diseñado para resultados duraderos.
          </p>
        </div>

        <div className="relative" data-id="element-93">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-emerald-100 -translate-y-1/2 z-0" data-id="element-94"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-95">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-white rounded-2xl p-8 border-2 border-emerald-50 shadow-sm relative flex flex-col items-center text-center" data-id="element-96">
                <div className="w-16 h-16 bg-emerald-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-emerald-600/30 ring-4 ring-white" data-id="element-97">
                  {phase.number}
                </div>
                <span className="text-sm font-bold text-amber-500 uppercase tracking-wider mb-2" data-id="element-98">
                  {phase.duration}
                </span>
                <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-99">
                  {phase.title}
                </h3>
                <p className="text-stone-600" data-id="element-100">{phase.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-20 bg-amber-50 rounded-3xl p-8 md:p-12 text-center border border-amber-100" data-id="element-101">
          <h3 className="text-2xl font-bold text-stone-900 mb-4" data-id="element-102">
            Resultados que puedes ver y sentir
          </h3>
          <p className="text-lg text-stone-700 max-w-3xl mx-auto italic" data-id="element-103">
            "En los primeros 7 días, notarás un cambio radical no solo en la
            balanza (que suele bajar 2 a 3 kilos de líquido inflamatorio), sino
            en tu rostro: las bolsas bajo los ojos disminuyen y tu mandíbula se
            ve más definida. Es el rastro físico de que tu inflamación sistémica
            está bajando."
          </p>
        </motion.div>
      </div>
    </section>;
}